import HomePage from "./Pages/Home";
import EventsList from "./Pages/EventList";
import EventDetail from "./Pages/EventDetail";
import RegisterForm from "./Pages/RegisterForm";
import SuccessPage from "./Pages/SuccessPage";
import Nav from "./components/Nav";
import Toast from "./components/Toast";
import AdminRoute from "./Pages/AdminRoute";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Toast />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/events" element={<EventsList />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/register/:id" element={<RegisterForm />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/admin" element={<AdminRoute />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
